import React from "react";

import useHasRole, { useIsForeignClientContext } from "../lib/hooks/useHasRole";

export type RoleBlockProps = {
  roles: UserRole[];
  /**
   * Hide for a distributor/reseller Client Admin while they are acting on a
   * client below them in the tree.
   */
  blockInForeignContext?: boolean;
};

const RoleBlock = React.memo(
  ({
    children,
    roles = [],
    blockInForeignContext = false,
  }: React.PropsWithChildren<RoleBlockProps>) => {
    const hasRole = useHasRole(roles);

    const isForeignContext = useIsForeignClientContext();

    if (!hasRole) {
      return null;
    }

    if (blockInForeignContext && isForeignContext) {
      return null;
    }

    return <>{children}</>;
  },
);

export default RoleBlock;
